
import { defineComponent } from "vue";
import { ImagePreview } from "vant";

import { Swiper, SwiperSlide } from "swiper/vue";
import SwiperCore, { Navigation } from "swiper";
require("swiper/swiper.less");
require("swiper/components/navigation/navigation.less");

const SWIPER_COMPONENTS = {
  Swiper,
  SwiperSlide,
};

SwiperCore.use([Navigation]);
export default defineComponent({
  components: { ...SWIPER_COMPONENTS },

  data() {
    return {
      swiper: <any>null,
      tabIndex: 0,
      cultureList: [
        {
          name: '月嫂初心日',
          icon: 'https://mm2015.mamalaile.com.cn/64bf3ea8cbb6c450fe5a4bbf30d81e33.png',
          picList: [
            'https://mm2015.mamalaile.com.cn/c0a5a318d6a4090c02f67d2f5b8b43ec.png',
            'https://mm2015.mamalaile.com.cn/f2b9674531506954ed722d1268bbf44f.png',
            'https://mm2015.mamalaile.com.cn/8b1dd74889b871926507d712423913aa.png',
            'https://mm2015.mamalaile.com.cn/895e55b79b8bd4b449345a09b2ba3c89.png',
            'https://mm2015.mamalaile.com.cn/c5456d5f4bf587e2548d031a9657a64f.png',
            'https://mm2015.mamalaile.com.cn/16cff066cf35349e431dd426898f3dc4.png',
            'https://mm2015.mamalaile.com.cn/aab8993562e804906f5ebc224db9b863.png',
            'https://mm2015.mamalaile.com.cn/3102c95a8a6913802919f48ad0249e3a.png',
            'https://mm2015.mamalaile.com.cn/93e3345112ba8a25f8163330b5f8acb3.png',
            'https://mm2015.mamalaile.com.cn/6b196ee72e592f63ae47b71ba1acd505.png',
          ]
        },
        {
          name: '管理面对面',
          icon: 'https://mm2015.mamalaile.com.cn/573adf08d7603d41da591e67ceb83516.png',
          picList: [
            'https://mm2015.mamalaile.com.cn/8542794694ed9b745c6480e5228b1b33.png',
            'https://mm2015.mamalaile.com.cn/3fc609b020208bd95e54abff2b86216e.png',
            'https://mm2015.mamalaile.com.cn/0b5a7b1cc374f54341808ba4d040a7ea.png',
            'https://mm2015.mamalaile.com.cn/5cf476c84d102d80f8fe93d2b8757536.png',
            'https://mm2015.mamalaile.com.cn/a2435febcc59aa82c45b462e0ff2c96e.png',
            'https://mm2015.mamalaile.com.cn/fbe04c37a3989fe921ab674c427a92dc.png',
            'https://mm2015.mamalaile.com.cn/23498a30a917e3364a7cc6175e83f530.png',
            'https://mm2015.mamalaile.com.cn/8c468b8de7a2b8b951ebdaed6ee3e29a.png',
            'https://mm2015.mamalaile.com.cn/1f19d8002cacc562a06ee7b54070760f.png',
            'https://mm2015.mamalaile.com.cn/75be0650f7acb61deab83554891292c9.png',
          ]
        },
        {
          name: '月嫂家庭日',
          icon: 'https://mm2015.mamalaile.com.cn/08ed00dc110b64cc7dd1d5c0c19894b7.png',
          picList: [
            'https://mm2015.mamalaile.com.cn/07a1c6c2ba17e51d544a03b824e37c04.png',
            'https://mm2015.mamalaile.com.cn/fd160386918d68e95c3984771d6d6a4c.png',
            'https://mm2015.mamalaile.com.cn/bb6d9326cde5a4e689beccc76e963a16.png',
            'https://mm2015.mamalaile.com.cn/0cb97c5742b1205c8dedf67baec53b43.png',
            'https://mm2015.mamalaile.com.cn/16a010c4dd80248188808e5fa40f13a7.png',
            'https://mm2015.mamalaile.com.cn/4f5270828af523fc1fba8a6ff51dc7fb.png',
            'https://mm2015.mamalaile.com.cn/ea79943ea6e59e0167063f78eeb7a210.png',
            'https://mm2015.mamalaile.com.cn/6d17b6efefb8b73259f6bed8b4a84d0a.png',
            'https://mm2015.mamalaile.com.cn/2be85c68189a66816fd2d114562385b7.png',
          ]
        },
        {
          name: '月嫂年会',
          icon: 'https://mm2015.mamalaile.com.cn/46ed43bbf1d1a3f59a1b577b76cce67a.png',
          picList: [
            'https://mm2015.mamalaile.com.cn/e0c19bdc32218a85bc851622381cfa97.png',
            'https://mm2015.mamalaile.com.cn/1da23708875b6284892ad2156448db31.png',
            'https://mm2015.mamalaile.com.cn/97576f495ca9b0f0eef191c821c4caf3.png',
            'https://mm2015.mamalaile.com.cn/b761adcb2eadd62b2a8531cb16be47b0.png',
            'https://mm2015.mamalaile.com.cn/8e966c22e52e42e13a8e97d0245f59c0.png',
            'https://mm2015.mamalaile.com.cn/7654ca4e12c5f526076ee7fa956c4b66.png',
            'https://mm2015.mamalaile.com.cn/9b5bbfc397e51daa365c07985bfc5437.png',
            'https://mm2015.mamalaile.com.cn/13a0270ff9c66323e2e6f2b7798d916e.png',
            'https://mm2015.mamalaile.com.cn/3442de5f413434435a8ee2001f84f699.png',
            'https://mm2015.mamalaile.com.cn/3353e18d8f135f52c730d5e8c1cca2ef.png',
          ]
        },
        {
          name: '月嫂户外拓展',
          icon: 'https://mm2015.mamalaile.com.cn/74965e57afb5a61798fa3ebd0e8b517c.png',
          picList: [
            'https://mm2015.mamalaile.com.cn/3734bc8415b349501e8ad8f9b212ace3.png',
            'https://mm2015.mamalaile.com.cn/2f380b297f16cdbf8e584c40c1930a7f.png',
            'https://mm2015.mamalaile.com.cn/484bfc0afe69f3041818db46b4bc8eb6.png',
            'https://mm2015.mamalaile.com.cn/3f65d46b9e346f2b7064224706a51195.png',
            'https://mm2015.mamalaile.com.cn/41a3315653ec7818fdf832b7ed3e7751.png',
            'https://mm2015.mamalaile.com.cn/ba42d1eb3b0f3e077a610ee8bceec0f8.png',
            'https://mm2015.mamalaile.com.cn/735cfa72fe0d08a57845a9b6a4819902.png',
            'https://mm2015.mamalaile.com.cn/1f24e036e916e85ed7e81d83ef8754cf.png',
            'https://mm2015.mamalaile.com.cn/15a8b181c153b71c64e03e0059de9ac3.png',
            'https://mm2015.mamalaile.com.cn/15a8b181c153b71c64e03e0059de9ac3.png',
            'https://mm2015.mamalaile.com.cn/345a0f847248a0dff758357648596ca6.png',
          ]
        },
      ],
    };
  },

  methods: {
    switchTab(index: number) {
      this.tabIndex = index;
      this.swiper.slideTo(0);
    },

    previewImage(index: number) {
      ImagePreview({
        images: this.cultureList[this.tabIndex].picList,
        startPosition: index,
        closeable: true
      });
    }
  }
});
